import UserBaseUIListener from '@/UIListener/UserBaseUIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ComponentManager from '@/Management/ComponentManager';
import ControlFactory from '@/Factories/ControlFactory';
import MessageBoxViewModel from '@/ViewModels/Controls/MessageBoxViewModel';
import RADApplication from '@/Management/RADApplication';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import ListViewViewModel from '@/ViewModels/Views/ListViewViewModel';

export default class UserUIListener extends UserBaseUIListener {

    LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
    protected checkExternalAuthentication: boolean;

    constructor(params: any) {
        super();

        this.checkExternalAuthentication = this.paramOrDefault(params.checkExternalAuthentication, true);
    }

    /**
    * @override
    * @param context
    */
    public onBeforeRender(context: DetailViewContext): void {
        super.onBeforeRender(context);

        this.updateLightUser(context);
    }

    public onDetailViewReady(context: DetailViewContext): void {
        super.onDetailViewReady(context);
        if (this.checkExternalAuthentication) {
            this.updateIsExternAuthentification(context);
        }
    }

    public onPropertyValueUpdated(context: DetailViewContext, property: string) {
        super.onPropertyValueUpdated(context, property);

        if (property == 'IsExternAuthentification') {
            if (this.checkExternalAuthentication) {
                this.updateGui(context);
                this.updateIsExternAuthentification(context);
            }
        }
    }

    public onBeforeCallOperation(context: ListViewViewModel, operation: string): boolean | JQueryDeferred<boolean> | JQueryPromise<boolean> {
        if (operation === 'Anonymize') {
            let result = $.Deferred();
            let msgVM = MessageBoxViewModel.createOkayCancelMessageBox(
                null,
                'USER_ANONYMIZE_MESSAGE_TEXT',
                () => { result.resolve(true); },
                () => { result.resolve(false); },
                '.YesNoMessageBox');

            msgVM.window.headline = new this.LabelViewModel({ ergName: "USER_ANONYMIZE_MESSAGE_TITLE" });

            RADApplication.getInstance().showMessageBox(msgVM);
            return result;
        }

        return super.onBeforeCallOperation(context, operation);
    }

    public updateGui(context: DetailViewContext) {
        super.updateGui(context);

        let externalAuthentication = context.genericObject.getObservable('IsExternAuthentification')();
        let isOnlyExternAuthentificationForExternalUsers = context.genericObject.getValueReturnNullIfNotExists('IsOnlyExternAuthentificationForExternalUsers');
        let password = context.getUIFactory('Password') as ControlFactory;
        let passwordRepeat = context.getUIFactory('PasswordRepeat') as ControlFactory;

        let changeNextLogin = context.getUIFactory('ChangePasswordWithNextLogin') as ControlFactory;

        if (password) {
            if (!externalAuthentication && !password.isRequired()) {
                password.isRequired(true);
                password.isEnabled(true);
                if (passwordRepeat) {
                    passwordRepeat.isRequired(true);
                    passwordRepeat.isEnabled(true);
                }

                if (changeNextLogin)
                    changeNextLogin.isEnabled(true);

            } else if (externalAuthentication && password.isRequired()) {
                password.isRequired(false);
                password.isValid(true);



                if (passwordRepeat) {
                    passwordRepeat.isRequired(false);
                    passwordRepeat.isValid(true);
                }

                if (isOnlyExternAuthentificationForExternalUsers === true) {
                    password.isEnabled(false);
                    if (passwordRepeat) {
                        passwordRepeat.isEnabled(false);
                    }

                    if (changeNextLogin) {
                        changeNextLogin.isEnabled(false);
                    }
                }
            }
        }
    }

    private updateIsExternAuthentification(context: DetailViewContext): void {
        const isExternAuthentification = context.genericObject.getValue('IsExternAuthentification');

        this.setFactoryEnabled('IsExternalSynchronisation', isExternAuthentification, context);
        this.setFactoryEnabled('IsTwoFA', !isExternAuthentification, context);

        if (!isExternAuthentification) {
            this.updateValue('IsExternalSynchronisation', false, context);
        } else {
            this.updateValue('IsTwoFA', false, context);
            this.updateValue('ChangePasswordWithNextLogin', false, context);
        }
    }

    private updateLightUser(context: DetailViewContext): void {
        if (!context.genericObject.getValue('SetLightUser'))
            return;

        this.updateValue('SetLightUser', true, context);
    }

    private setFactoryEnabled(name: string, isEnabled: boolean, context: DetailViewContext ): void {
        const factory = context.getUIFactory(name) as ControlFactory;
        if (factory) {
            factory.isEnabled(isEnabled);
        }
    }

    private updateValue(name: string, value: any, context: DetailViewContext): void {
        const obs = context.genericObject.getObservable(name);
        if (obs)
            obs(value);
    }
}

ComponentManager.setUIListener('UserUIListener', UserUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.UserUIListener', UserUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');